import { BLACKLIST_API_BASE } from './constants';

const joinUrl = (base, path) => {
  if (!base) return path;
  return base.endsWith('/') ? base + path : base + '/' + path;
};

const GET_URL = () => joinUrl(BLACKLIST_API_BASE, 'blacklist_get.php');
const SET_URL = () => joinUrl(BLACKLIST_API_BASE, 'blacklist_set.php');

export const emptyList = () => ({ addresses: [], ids: [] });

export async function fetchBlacklist() {
  try {
    const res = await fetch(GET_URL(), { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return {
      addresses: Array.isArray(data.addresses)
        ? data.addresses.map((a) => String(a).toLowerCase())
        : [],
      ids: Array.isArray(data.ids) ? data.ids.map((v) => String(v)) : [],
    };
  } catch (err) {
    console.warn('fetchBlacklist failed:', err);
    return emptyList();
  }
}

export function isBlacklisted(list, account, userId) {
  if (!list) return { blocked: false };
  const addr = account ? String(account).toLowerCase() : '';
  const id = userId != null ? String(userId) : '';
  if (addr && list.addresses && list.addresses.includes(addr)) {
    return { blocked: true, reason: 'address' };
  }
  if (id && list.ids && list.ids.includes(id)) {
    return { blocked: true, reason: 'id' };
  }
  return { blocked: false };
}

// action: 'add' | 'remove', type: 'address' | 'id', value: string
export async function setBlacklistEntry({ action, type, value, adminKey }) {
  if (!adminKey) throw new Error('Admin key is required');
  const res = await fetch(SET_URL(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Admin-Key': adminKey,
    },
    body: JSON.stringify({ action, type, value }),
  });
  const text = await res.text();
  let data = null;
  try { data = JSON.parse(text); } catch (_) { /* not json */ }
  if (!res.ok) {
    const msg = (data && data.error) || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data || {};
}
